define('util/observable',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Observable = void 0;
    /**
     * Observable value.
     */
    var Observable = /** @class */ (function () {
        function Observable(item) {
            this.listeners = [];
            this.item = item;
        }
        Observable.prototype.subscribe = function (listener) {
            this.listeners.push(listener);
        };
        /**
         * Subscribe and also call listener with current value
         */
        Observable.prototype.subscribeNow = function (listener) {
            this.subscribe(listener);
            listener(this.item);
        };
        Observable.prototype.get = function () {
            return this.item;
        };
        Observable.prototype.set = function (item) {
            // TODO: Only notify listeners if something changed?
            this.item = item;
            // Notify listeners
            for (var _i = 0, _a = this.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener(item);
            }
        };
        return Observable;
    }());
    exports.Observable = Observable;
});
//# sourceMappingURL=/assets/javascripts/util/observable.js.map;
